import { render } from "./NFLTotals.vue?vue&type=template&id=547d13d7"
import script from "./NFLTotals.vue?vue&type=script&lang=js"
export * from "./NFLTotals.vue?vue&type=script&lang=js"

import "./NFLTotals.vue?vue&type=style&index=0&id=547d13d7&lang=css"

import exportComponent from "/github/workspace/ff-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__